<td>
  <div class="RecipeBox" width="150px" height="120px">
    <img
      class="RecipeThumbnail"
      [src]="myRecipe().imageFilename"
      [title]="myRecipe().name | uppercase"
      [alt]="myRecipe().name"
      [style.margin.px]="imageMargin"
    />
  </div>
</td>
<td>
  <a [href]="myRecipe().filename" target="_blank" rel="noopener noreferrer">{{ myRecipe().name }}</a>
</td>
<td>
  <ngb-rating [rate]="stars()" [readonly]="true" [max]="4" />
</td>
